import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const LicenseValidation = z.object({
  name: z.string({ required_error: '[License] name is required' }),
  value: z.string({ required_error: '[License] value is required' }),
})

export class License extends Model {
  static create({ name, value }: z.infer<typeof LicenseValidation>) {
    LicenseValidation.parse({ name, value })
    return new License(name, value)
  }

  static createOrNull(params: z.infer<typeof LicenseValidation>): License | null {
    try {
      return License.create(params)
    } catch {
      return null
    }
  }

  static fromJSON(json: ReturnType<License['toJSON']>): License {
    return License.create({ name: json.name, value: json.value })
  }

  constructor(
    private readonly _name: string,
    private readonly _value: string
  ) {
    super()
  }

  name() {
    return this._name
  }

  value() {
    return this._value
  }

  toJSON() {
    return {
      name: this._name,
      value: this._value,
    }
  }
}
